<template lang="pug">
	.standings-table
		.standings-header
			span Blitztabelle

			.buttons.header-action
				//- Reload button, visible on error when not already loading
				button.button.is-outlined.is-light.is-small(
					v-if="!isLoading && fetchError"
					@click="fetchStandings()"
				)
					i.fas.fa-sync

				//- Expand/collapse button
				button.button.is-outlined.is-light.is-small(
					v-if="standingRows && standingRows.length"
					@click="isExpanded = !isExpanded"
				)
					i.fas.fa-chevron-down(v-if="isExpanded")
					i.fas.fa-chevron-right(v-else)

				//- Loading indicator (spinning football)
				.loading-indicator(
					v-if="isLoading"
				)
					i.fas.fa-futbol.fa-spin

		transition(name="collapse")
			.standings-body(
				v-if="standingRows && isExpanded"
			)
				table
					thead
						tr
							th #
							th Verein
							th S
							th G/U/V
							th T
							th P
					tbody
						tr(v-for="row in standingRows")
							td {{ row.position }}
							td.club.is-flex
								img.image.is-24x24(:src="row.logo", style="margin-right: 1rem;")
								span {{ row.nameShort }}
							td {{ row.played }}
							td {{ row.won }}/{{ row.draw }}/{{ row.lost }}
							td {{ row.goalsFor }}:{{ row.goalsAgainst }}
							td {{ row.points }}
</template>

<script>
import { setInterval, clearInterval } from 'timers'
import { KSVSportsdataBroker, KSVSportsdataCategories } from '@custom-media/ksv-sportsdata-broker/dist/data-broker.js'

const FETCH_INTERVAL = 1 * 60 * 1000
export default {
	data () {
		return {
			broker: KSVSportsdataBroker.instance(),
			isLoading: true,
			isExpanded: true,
			fetchError: null,
			interval: null
		}
	},
	created () {
		this.fetchStandings()
		this.interval = setInterval(this.fetchStandings, FETCH_INTERVAL)
	},

	computed: {
		standingRows () {
			const rows = 10
			if (!this.broker.standings) { return this.broker.standings }
			let position = this.broker.standings.findIndex(s => s.nameShort === 'KSV')
			const startPosition = Math.max(position - Math.ceil((rows - 1) / 2), 0)

			return this.broker.standings.slice(startPosition, rows)
		}
	},
	destroyed () {
		if (this.interval) {
			clearInterval(this.interval)
			this.interval = null
		}
	},
	methods: {
		async fetchStandings () {
			this.isLoading = true
			await this.broker.fetch([KSVSportsdataCategories.standings], { force: true })
			this.isLoading = false
		}
	}
}
</script>
<style lang="scss" scoped>

	@import '@/assets/scss/bulma-variables.scss';

	.standings-table {
		background: white;
		.standings-header {
			display: flex;
			align-items: center;
			padding: 0.5em 1em;
			background: $primary;
			color: $white;
			font-weight: bold;
			font-size: 1.25em;

			justify-content: space-between
		}

		.standings-body {
			max-height: 3000px;
			overflow: hidden;
			&.collapse-enter-active,
			&.collapse-leave-active {
				transition: max-height 0.5s ease-out;
			}
			&.collapse-enter,
			&.collapse-leave-to {
				max-height: 0;
			}
		}

		table {
			tr {
				padding: 0.25em 1em;
				border-bottom: 1px solid $light;
			}
			td {
				padding: .25em .5em;
				text-align: center;
				&.club {
					text-align: left;
				}
				&:first-child {
					padding-left: 1em;
				}
				&:last-child {
					padding-right: 1em;
				}
			}
		}
	}
</style>
